<template>
  <div class="pt dinline-block vtop mb10 pl25 pr25 lh18 tc6" style="position:relative;" :style="{background: 'url('+item.pic+') no-repeat'}">
    <div class="nm fs16 fbold pt10 pb5 tz" >
      <span>{{item.name}}</span>
    </div>
    <div>
      <a href="javascript:;" @click="goSign()" class="tz-button">网上报名</a>
    </div>
    <div class="qrcode-div" :id="'qrcode-item-div'+item.id" ></div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "itemJn",
  props:[
    'item'
  ],
  mounted() {
    this.$nextTick(() => {
      this.creatQrCode('qrcode-item-div'+this.item.id,this.item.id,this.item.name)
    })
  },
  methods:{
    creatQrCode(qrCodeUrl,id,name) {
      var docd = document.getElementById(qrCodeUrl);
      var that = this;
      if(docd){
        docd.innerHTML='';
        var qrcode = new QRCode(docd, {
          text: 'http://'+document.domain+that.$router.options.base+'train/project/sign?id='+id+'&name='+name, // 需要转换为二维码的内容
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }
    },
    goSign:function () {
      localStorage.setItem('ITEMJN',this.item.work_option);
      this.$router.push(`/train/project/sign?id=${this.item.id}&name=${this.item.name}`);//:to="`/train/project/sign?id=${item.id}&name=${item.name}`"
    }
  }
}
</script>

<style scoped>
  .pt{margin: 0 12px 10px;width: 365px;height: 170px;background: #ecf0f4;}
  .pt:hover{box-shadow: 0 0 8px #666;}
  .pt .zbtn{padding: 6px 13px;}



  .tz{font-size: 22px;
    margin-top: 15px;
    margin-left: 175px;
    overflow: hidden;
    height: 96px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;}
  .tz span{color: rgb(102,104,103);}
  .tz span::before{content:url(../../../assets/images/tran.png);position: relative;top:4px;}
  .tz-button{display:inline-block;text-align:center;margin-top: 10px;margin-left: 175px;width: 88px;height: 30px;line-height: 30px;font-size: 14px;background: #147ad8;border: none;border-radius: 15px;color: #fff;}
  .qrcode-div{position: absolute;left: 0;bottom: 0;width:100px;height: 100px;background: red;}
</style>



// WEBPACK FOOTER //
// src/components/train/project/itemJn.vue